import React from 'react';
import {Field} from 'react-final-form';
import {ACCESSIBILITY_ITEMS, parseAccessibilityValue, serializeAccessibilityValue} from '../../assets/accessibility/accessibilityCodelist';
import './AccessibilityField.scss';

type Props = {
    name: string;
    label: React.ReactNode;
    disabled?: boolean;
};

/**
 * Editační widget atributu typu Přístupnost pro vozíčkáře – výběr vícehodnotového kódu přístupnosti
 * formou klikatelných ikon (checkbox skrytý pod `label`). Sdíleno mezi editací jednoho objektu
 * (AttributesModal) a hromadnou editací (BulkEditModal).
 */
export const AccessibilityField: React.FC<Props> = ({name, label, disabled}) => (
    <div className="mb-2">
        <div className="mb-1">{label}</div>
        <Field name={name}>
            {({input}) => {
                const selectedCodes = new Set<string>(parseAccessibilityValue(input.value as string));
                return (
                    <div className="accessibility-items">
                        {ACCESSIBILITY_ITEMS.map(item => {
                            const selected = selectedCodes.has(item.kod);
                            return (
                                <label
                                    key={item.kod}
                                    title={item.nazev}
                                    className={['accessibility-item', selected && 'accessibility-item--selected', disabled && 'accessibility-item--disabled']
                                        .filter(Boolean)
                                        .join(' ')}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selected}
                                        disabled={disabled}
                                        className="d-none"
                                        onChange={e => {
                                            const next = new Set(selectedCodes);
                                            if (e.target.checked) next.add(item.kod);
                                            else next.delete(item.kod);
                                            input.onChange(serializeAccessibilityValue([...next]));
                                        }}
                                    />
                                    <img src={item.icon} alt={item.nazev} className="accessibility-item__icon" />
                                    <span className="accessibility-item__label">{item.nazev}</span>
                                </label>
                            );
                        })}
                    </div>
                );
            }}
        </Field>
    </div>
);
